module.exports = {};

const development = require('./configs/development');
const staging = require('./configs/staging');
const production = require('./configs/production');
const hetzner = require('./configs/hetzner');

function readEnvironment() {
  if (typeof (GLOBAL_ENVIRONMENT) !== 'undefined') {
    return GLOBAL_ENVIRONMENT;
  }
  return 'development';
}

module.exports.get = () => {
  const environment = readEnvironment().toLowerCase();

  switch (environment) {
    case 'development':
      return development;

    case 'staging':
      return staging;

    case 'production':
      return production;

    case 'hetzner':
      return hetzner;

    default:
      throw new Error('unable to read configuration');
  }
};
